//import enums
import { AccessLevelEnum, UtilityTypeEnum, UserMappingAccessLevelEnum, UserProfileFeatureTypeEnum, HeatingTypeEnum, HousingTypeEnum, TarificationIdEnum, ContractReasonEnum, CustomerTypeEnum, ContactPersonTypeEnum, ProcessTypeEnum, CISContractStatusEnum, ContractTypeEnum, InvoicingMethodEnum, ProcessStatusEnum, ProductTypeEnum, RuleTypeEnum, ContractContactPersonTypeEnum } from "./CommonEnums";

//import DataModels
import { IAddress, IUserProfileFeature } from "./I4UDataModels";

//A
export interface IAccountInfoViewModel {
    Me: IUserInfoViewModel;
    MyCustomers: ICustomershipViewModel[];
    MyLinkedUsers: ILinkedUserModel[];
    MyConnections: Iterable<any>;//Iterable<ConnectionViewModel>;ConnectionViewModel[]
    ContactPersons: IEnerityContactPersonViewModel[];
}
export interface IEnerityContactPersonViewModel {
    Name: string;
    FirstName: string;
    LastName: string;
    ExternalId: string;
    SourceCompanyCode: string;
    ContactPersonType: ContactPersonTypeEnum;
    ContractCode: string;
    UtilityTypeId: number;
}

export interface IAdditionalContractViewModel {
    Id: number;
    Status: ProcessStatusEnum;
    ExtraInformation: string;
    MeteringPoint: IMeteringPointViewModel;
    Utility: UtilityTypeEnum;
}

export interface IAdditionalMeteringPointViewModel {
    Address: IAddressViewModel;
    MeteringPointCode: string;
    NetworkCompanyCode: string;
    NetworkCompanyName: string;
    ContractReason: number;
    StartDate : Date;
}

export interface IAddressViewModel {
    Street: string;
    Zip: string;
    Place: string;
    Country: string;
    COName: string;
    StreetName: string;
    HouseNumber: string;
    Staircase: string;
    Apartment: string;
    Specifier: string;
    Locale: string;
}

export class AddressViewModel implements IAddressViewModel {
    Street: string = null;
    Zip: string = null;
    Place: string = null;
    Country: string = null;
    COName: string = null;
    StreetName: string = null;
    HouseNumber: string = null;
    Staircase: string = null;
    Apartment: string = null;
    Specifier: string = null;
    Locale: string = null;

    public static copy(other: IAddressViewModel): AddressViewModel {
        return {
            Street: other.Street,
            Zip: other.Zip,
            Place: other.Place,
            Country: other.Country,
            COName: other.COName,
            StreetName: other.StreetName,
            HouseNumber: other.HouseNumber,
            Staircase: other.Staircase,
            Apartment: other.Apartment,
            Specifier: other.Specifier,
            Locale: other.Locale
        }
    }
}

export interface IAdditionalBasicPriceViewModel {
    BasicDescription: string;
    BasicPriceUnit: string;
    BasicPrice: number;
    BasicPriceNoVAT: number;
    OrderNumber: number;
}

export interface IAlternativePriceViewModel
{
    Code: string;
}

//B
//C
export interface ICompanyViewModel {
    Id: number;
    TrustedSource: boolean;
    CompanyName: string;
    BusinessId: string;
    Email: string;
    Phone: string;
    CustomerCode: string;
    CompanySource: number;
    CultureCode: string;
    SourceCompanyCode: string;
    EPaymentCode: string;
    EPaymentOperator: string;
    EPaymentOperatorId: number;
    Address: IAddressViewModel;
    InvoicingAddress: IAddressViewModel;
    ContactPersons: IContactPersonViewModel[];
    Deposit: boolean;
    MarketingBanPhone: boolean;
    MarketingBanEmail: boolean;
    MarketingChannelEmail: boolean;
    MarketingChannelSMS: boolean;
    MarketingChannelElec: boolean;
    DirectMarketing: boolean | null;
    ExistingCustomer: boolean;
    CustomerIdExternal: number;
    ServiceChannelCode: string;
    ContractPartners: IContactPersonViewModel[];
    HasAcceptedTAC: boolean;
    TACAcceptedDate : Date;
}

export class CompanyViewModel implements ICompanyViewModel {
    Id: number;
    TrustedSource: boolean;
    CompanyName: string;
    BusinessId: string;
    Email: string;
    Phone: string;
    CustomerCode: string;
    CompanySource: number;
    CultureCode: string;
    SourceCompanyCode: string;
    EPaymentCode: string;
    EPaymentOperator: string;
    EPaymentOperatorId: number;
    Address: IAddressViewModel = new AddressViewModel();
    InvoicingAddress: IAddressViewModel = new AddressViewModel();
    ContactPersons: IContactPersonViewModel[] = [];
    Deposit: boolean;
    MarketingBanPhone: boolean;
    MarketingBanEmail: boolean;
    MarketingChannelEmail: boolean;
    MarketingChannelSMS: boolean;
    MarketingChannelElec: boolean;
    DirectMarketing: boolean | null;
    ExistingCustomer: boolean;
    CustomerIdExternal: number;
    ServiceChannelCode: string;
    ContractPartners: IContactPersonViewModel[] = [];
    HasAcceptedTAC: boolean;
    TACAcceptedDate: Date;
}

export interface IContactPersonViewModel {
    Id: number;
    FirstName: string;
    LastName: string;
    Pin: string;
    Email: string;
    Phone: string;
    Type: ContactPersonTypeEnum;
    Address: IAddressViewModel;
    HasAcceptedTAC: boolean;
    TACAcceptedDate: Date;
    ContactPersonRole: ContractContactPersonTypeEnum;
    ContactPersonRoleInfo: string;
}

export interface ICustomerMembershipViewModel{
    MembershipName: string;
    MembershipCode: string;
    MembershipTypeId: number;
    MembershipDescription: string;
}

export class CustomerMembershipViewModel implements ICustomerMembershipViewModel {
    MembershipName: string;
    MembershipCode: string;
    MembershipTypeId: number;
    MembershipDescription: string;
}

export interface IContractMembershipViewModel {
    MembershipType: number;
    MembershipName: string;
    MembershipDescription: string;
    MembershipCode: string;
}

export class ContractMembershipViewModel implements IContractMembershipViewModel {
    MembershipType: number;
    MembershipName: string;
    MembershipDescription: string;
    MembershipCode: string;
}

export interface IMembershipTypeViewModel {
    MembershipTypeId: number;
    Name: string;    
    Description: string;
}

export class ContactPersonViewModel {
    Id: number;
    FirstName: string;
    LastName: string;
    Pin: string;
    Email: string;
    Phone: string;
    Type: ContactPersonTypeEnum;
    Address: IAddressViewModel = new AddressViewModel();
    HasAcceptedTAC: boolean;
    TACAcceptedDate: Date;
    ContactPersonRole: ContractContactPersonTypeEnum;
    ContactPersonRoleInfo: string;
}

export interface IContractOriginInfoViewModel {
    Origin: string;
    Channel: string;
}

export interface IContractsProductViewModel {
    ProductName: string;
    TarificationName: string;
    FixedFeeName: string;
    Energy1Name: string;
    Energy2Name: string;
    FixedFeePrice: number;
    FixedFeeUnit: string;
    Energy1Price: number;
    Energy2Price: number;
    TotalPrice: number;
    TotalConsumption: number;
}

export interface IContractViewModel {
    HeatingTypeId: HeatingTypeEnum;
    HousingTypeId: HousingTypeEnum;
    TarificationId: TarificationIdEnum;
    Registers: number;
    OldFixedPeriodTime: number;
    ValuationId: number;
    // 0 = other network
    // 1 = home network
    // null = not set
    ContractLocation: number;
    HouseArea: number;
    ProductId: number;
    PriceListId: number;
    ContractMembership: IContractMembershipViewModel;
    //trasanen 9.12.2014 PKSYP-42 Must be able to save n products when asking offer
    // public List < ContractProductViewModel > Products { get; set; }
    Energy1: number;
    Energy2: number;
    Reading1: number;
    Reading2: number;
    ContractSpecificBasicPrice: number;
    ContractSpecificEnergy1Price: number;
    ContractSpecificEnergy2Price: number;
    IsAmr: number;
    InvoicingGroup: number;
    UsageGroupName: string;
    StartDate: Date;
    StoredStartDate: Date;
    DueDate: number;
    OfferValidUntilDate: Date;
    AddressValidFrom: Date;
    RefundInvoice: boolean;
    AcceptTerms: boolean;
    EnableSendingNewContractConfirmation: boolean;
    PropertyTrade: boolean;
    TestMode: boolean;
    CreditTransfers: number;
    CreditAccount: string;
    ConfirmationChannel: number;
    ContractReason: ContractReasonEnum;
    PaymentMethod: number; // Is this PaymentMethodTypeEnum?
    // public List < ProcessInformation > ProcessInformations { get; set; }
    ExtraInformation: string;
    LoadModel: string;
    AnnuityInvoicing: number;
    InvoicingMethod: InvoicingMethodEnum
    DiscountPercent: number;
    MembershipCode: string;
    Customer: ICustomerViewModel;
    Company: ICompanyViewModel;
    MeteringPoint: IMeteringPointViewModel;
    AdditionalMeteringPoint: IAdditionalMeteringPointViewModel[];
    IsInvoicingAddressInUse: boolean;
    IsCustomerAddressInUse: boolean;
    DeliveryEmail: string;
    InvoicingAddress: IInvoicingAddressViewModel;
    CreditInformation: ICreditInformationViewModel;
    LastActivity: Date;
    TupasAuthId: number;
    PermissionToSearchContactData: boolean;
    ProductChanged: boolean;
    ProductChangeProcess: boolean;
    OldContract: boolean;
    OldContractCode: string;
    ConnectionFee: number;
    ConnectionContractTransfers: boolean;
    DistrictHeatContractPermission: boolean;
    Status: string;
    HomeNetwork: string;
    HomeNetworkByAddress: string;
    Id: number;
    CustomerType: CustomerTypeEnum;
    HousingType: HousingTypeEnum;
    PropertyType: number;
    ProcessType: ProcessTypeEnum;
    OldContractEndDate: Date;
    OldFixedTermContractEndDateByUser: Date;
    EndDate: Date;
    OldMeteringPoint: IMeteringPointViewModel;
    OldSalesCompany: string;
    SupplierChangeStatus: number;
    CreatedUser: string;
    Created: Date;
    LockedUser: string;
    LockedTime: Date;
    OfferId: string;
    CustomerContracts: IOtherContractViewModel[];
    MeteringPointContracts: IOtherContractViewModel[];
    OldMeteringPointContracts: IOtherContractViewModel[];
    Phase: number;
    MaxPhase: number;
    ContinuationContract: string;
    ExtranetContract: boolean;
    ExternalProductId: string;
    Error: string;
    MoveOutProcess: IMoveOutProcessViewModel;
    ExtraFeatures: IExtraFeatureViewModel[];
    // From ContractProcess, values defined in ProcessStatusEnum.
    MoveOutStatus: ProcessStatusEnum;
    NewContractStatus: ProcessStatusEnum;
    IsAcceptingOffer: boolean;
    HasAcceptedContract: boolean;
    CampaignCode: string;
    ConfirmationAddress: IAddressViewModel;
    SubProcessType: number; // What is this?
    ContractTypes: number;  // What is this?
    ExistingContracts: number;
    OldContractsProduct: IContractsProductViewModel;
    PropertyOwnerName: string;
    PropertyOwnerContactInformation: string;
    DHInvoicingName: string;
    DHInvoicingContactInformation: string;
    Brand: string;
    OfferCreated: Date;
    InvoicingMethodSelected: boolean;
    PaperInvoiceAllowed: boolean;
    OtherAddressSelected: boolean;
    DHMeteringPoint: boolean;
    GasMeteringPoint: boolean;
    IsFollowUpContract: boolean;
    ContractDate: Date;
    ContractOriginInfo: IContractOriginInfoViewModel;
    ExtraServiceOrder: number;
    isNewContractBasedOnOld: boolean;
    AdditionalContracts: IAdditionalContractViewModel[];
    ContractCode: string;
    IsSafeToConnect: boolean;
    IsConnected: boolean;
    DocumentTemplateName: string;
    ExternalOfferId: string;
    SalesChannel: string;
    PreSelectedProductAndPriceList: boolean;
    PreSelectedMembership: string;
    MarketingPermissionEmailCustomer: boolean;
    DirectMarketingSelected: boolean;
    IsEstateOwner: boolean;
    MovingOutContracts: IMovingSelectionViewModel;
	MembershipType: number;
    StrongContractAuthentication: boolean;
    AuthenticateQuestionAccepted: boolean;
    ContractToNewAddressSelection: number;
}

export class ContractViewModel implements IContractViewModel {
    HeatingTypeId: HeatingTypeEnum;
    HousingTypeId: HousingTypeEnum;
    TarificationId: TarificationIdEnum;
    Registers: number;
    OldFixedPeriodTime: number;
    ValuationId: number;
    ContractLocation: number;
    HouseArea: number;
    ProductId: number;
    PriceListId: number;
    ContractMembership: IContractMembershipViewModel = new ContractMembershipViewModel();
    Energy1: number;
    Energy2: number;
    Reading1: number;
    Reading2: number;
    ContractSpecificBasicPrice: number;
    ContractSpecificEnergy1Price: number;
    ContractSpecificEnergy2Price: number;
    IsAmr: number;
    InvoicingGroup: number;
    UsageGroupName: string;
    StartDate: Date;
    StoredStartDate: Date;
    DueDate: number;
    OfferValidUntilDate: Date;
    AddressValidFrom: Date;
    RefundInvoice: boolean;
    AcceptTerms: boolean;
    EnableSendingNewContractConfirmation: boolean;
    PropertyTrade: boolean;
    TestMode: boolean;
    CreditTransfers: number;
    CreditAccount: string;
    ConfirmationChannel: number;
    ContractReason: ContractReasonEnum;
    PaymentMethod: InvoicingMethodEnum;
    // public List < ProcessInformation > ProcessInformations { get; set; }
    ExtraInformation: string;
    LoadModel: string;
    AnnuityInvoicing: number;
    InvoicingMethod: number
    DiscountPercent: number;
    MembershipCode: string;
    Customer: ICustomerViewModel = new CustomerViewModel();
    Company: ICompanyViewModel = new CompanyViewModel();
    MeteringPoint: IMeteringPointViewModel = new MeteringPointViewModel();
    AdditionalMeteringPoint: IAdditionalMeteringPointViewModel[] = [];
    IsInvoicingAddressInUse: boolean;
    IsCustomerAddressInUse: boolean;
    DeliveryEmail: string;
    InvoicingAddress: IInvoicingAddressViewModel = new InvoicingAddressViewModel();
    CreditInformation: ICreditInformationViewModel = new CreditInformationViewModel();
    LastActivity: Date;
    TupasAuthId: number;
    PermissionToSearchContactData: boolean;
    ProductChanged: boolean;
    ProductChangeProcess: boolean;
    OldContract: boolean;
    OldContractCode: string;
    ConnectionFee: number;
    ConnectionContractTransfers: boolean;
    DistrictHeatContractPermission: boolean;
    Status: string;
    HomeNetwork: string;
    HomeNetworkByAddress: string;
    Id: number;
    CustomerType: CustomerTypeEnum;
    HousingType: HousingTypeEnum;
    PropertyType: number;
    ProcessType: ProcessTypeEnum;
    OldContractEndDate: Date;
    OldFixedTermContractEndDateByUser: Date;
    EndDate: Date;
    OldMeteringPoint: IMeteringPointViewModel = new MeteringPointViewModel();
    OldSalesCompany: string;
    SupplierChangeStatus: number;
    CreatedUser: string;
    Created: Date;
    LockedUser: string;
    LockedTime: Date;
    OfferId: string;
    CustomerContracts: IOtherContractViewModel[] = [];
    MeteringPointContracts: IOtherContractViewModel[] = [];
    OldMeteringPointContracts: IOtherContractViewModel[] = [];
    Phase: number;
    MaxPhase: number;
    ContinuationContract: string;
    ExtranetContract: boolean;
    ExternalProductId: string;
    Error: string;
    MoveOutProcess: IMoveOutProcessViewModel;
    ExtraFeatures: IExtraFeatureViewModel[] = [];
    MoveOutStatus: ProcessStatusEnum;
    NewContractStatus: ProcessStatusEnum;
    IsAcceptingOffer: boolean;
    HasAcceptedContract: boolean;
    CampaignCode: string;
    ConfirmationAddress: IAddressViewModel = new AddressViewModel();
    SubProcessType: number; // What is this?
    ContractTypes: number;  // What is this?
    ExistingContracts: number;
    OldContractsProduct: IContractsProductViewModel;
    PropertyOwnerName: string;
    PropertyOwnerContactInformation: string;
    DHInvoicingName: string;
    DHInvoicingContactInformation: string;
    Brand: string;
    OfferCreated: Date;
    InvoicingMethodSelected: boolean;
    PaperInvoiceAllowed: boolean;
    OtherAddressSelected: boolean;
    DHMeteringPoint: boolean;
    GasMeteringPoint: boolean;
    IsFollowUpContract: boolean;
    ContractDate: Date;
    ContractOriginInfo: IContractOriginInfoViewModel;
    ExtraServiceOrder: number;
    isNewContractBasedOnOld: boolean;
    AdditionalContracts: IAdditionalContractViewModel[] = [];
    ContractCode: string;
    IsSafeToConnect: boolean;
    IsConnected: boolean;
    DocumentTemplateName: string;
    ExternalOfferId: string;
    SalesChannel: string;
    PreSelectedProductAndPriceList: boolean;
    PreSelectedMembership: string;
    MarketingPermissionEmailCustomer: boolean;
    DirectMarketingSelected: boolean;
    IsEstateOwner: boolean;
    MovingOutContracts: IMovingSelectionViewModel;
	MembershipType: number;
    StrongContractAuthentication: boolean;
    AuthenticateQuestionAccepted: boolean;
    ContractToNewAddressSelection: number;
}

export interface IMovingSelectionViewModel {
    Customers: ICustomerViewModel[];
    Companies: ICompanyViewModel[];
    Utilities: object[];
    MeteringPointAddress: string;
    AddressId: string;
}

export interface IConsumptionReportSubscriptionViewModel {
    ReportSubscriptionId: number;
    CustomerCode: string;
    SourceCompanyCode: string;
    MeteringPointCode: string;
    MpSourceCompanyCode: string;
    Email: string;
    WeeklyReport: boolean;
    MonthlyReport: boolean;
    Culture: string;
    UserName: string;
    ConsumptionReportSubscriptionEmails: IConsumptionReportSubscriptionEmailViewModel[];
}

export interface IConsumptionReportSubscriptionEmailViewModel {
    ConsumptionReportSubscriptionEmailId: number;
    Email: string;
    WeeklyReportOrdered: boolean;
    MonthlyReportOrdered: boolean;
    Language: string;

}

export interface ICreditInformationViewModel {
    IsCreditOk: boolean;
    PaymentDefaults: IPaymentDefaultViewModel[];
    ErrorCode: string;
    ErrorText: string;
    ClassificationCode: string;
    ClassificationDescription: string;
    LastUpdated : Date;
    Id: number;
    Source: number;
}

export class CreditInformationViewModel implements ICreditInformationViewModel {
    IsCreditOk: boolean;
    PaymentDefaults: IPaymentDefaultViewModel[] = [];
    ErrorCode: string;
    ErrorText: string;
    ClassificationCode: string;
    ClassificationDescription: string;
    LastUpdated: Date;
    Id: number;
    Source: number;
}

export interface ICustomerViewModel {
    Id: number;
    TrustedSource: boolean;
    Name: string;
    FirstName: string;
    LastName: string;
    OfferName: string;
    Pin: string;
    Email: string;
    Phone: string;
    CustomerCode: string;
    CustomerSource: number;
    SBonusCode: string;
    CultureCode: string;
    SourceCompanyCode: string;
    EPaymentCode: string;
    CustomerType: CustomerTypeEnum;
    EPaymentOperator: string;
    EPaymentOperatorId: number;

    Address: IAddressViewModel;
    InvoicingAddress: IAddressViewModel;
    ContractPartners: IContactPersonViewModel[];
    CustomerMemberships: ICustomerMembershipViewModel[];
    Deposit: boolean;
    MarketingBanPhone: boolean;
    MarketingBanEmail: boolean;
    MarketingChannelEmail: boolean;
    MarketingChannelSMS: boolean;
    MarketingChannelElec: boolean;
    DirectMarketing: boolean | null;
    ExistingCustomer: boolean;
    CustomerIdExternal: number;
    ServiceChannelCode: string;
    HasAcceptedTAC: boolean;
    TACAcceptedDate: Date;
}

export class CustomerViewModel implements ICustomerViewModel {
    Id: number;
    TrustedSource: boolean;
    Name: string;
    FirstName: string;
    LastName: string;
    OfferName: string;
    Pin: string;
    Email: string;
    Phone: string;
    CustomerCode: string;
    CustomerSource: number;
    SBonusCode: string;
    CultureCode: string;
    SourceCompanyCode: string;
    EPaymentCode: string;
    CustomerType: CustomerTypeEnum;
    EPaymentOperator: string;
    EPaymentOperatorId: number;

    Address: IAddressViewModel = new AddressViewModel();
    InvoicingAddress: IAddressViewModel = new AddressViewModel;
    ContractPartners: IContactPersonViewModel[];
    CustomerMemberships: ICustomerMembershipViewModel[] = new Array as CustomerMembershipViewModel[];
    Deposit: boolean;
    MarketingBanPhone: boolean;
    MarketingBanEmail: boolean;
    MarketingChannelEmail: boolean;
    MarketingChannelSMS: boolean;
    MarketingChannelElec: boolean;
    DirectMarketing: boolean | null;
    ExistingCustomer: boolean;
    CustomerIdExternal: number;
    ServiceChannelCode: string;
    HasAcceptedTAC: boolean;
    TACAcceptedDate: Date;
}

export interface ICustomerMeteringPointViewModel {
    MeteringPointCode: string;
    SourceCompanyCode: string;
    Address: IAddress;
    Utility: UtilityTypeEnum;
    }

export interface ICustomershipViewModel {
    CISCustomerId: number;
    Name: string;
    CustomerCode: string;
    SourceCompanyCode: string;
    CustomerType: number;
    OfficialAddress: IAddress;
    Pin: string;
    BusinessIdentifier: string;
    Phone: string;
    Email: string;
    MyAccessLevels: Map<string, UserMappingAccessLevelEnum>;//IDictionary<string, UserMappingAccessLevelEnum>;
    SharedCustomerRights: ISharedCustomerRightsViewModel[];
    MeteringPoints: ICustomerMeteringPointViewModel[];
}
//D
//E
export interface IExtraFeatureViewModel {
    ExtraFeatureId: number;
    Name: string;
    Amount: number;
    Price: number;
    Time: Date;
}
//F
export interface IFinalInvoicingAddressViewModel {
    Address: IAddressViewModel;
    IBAN: string;
    BIC: string;
    OVT: string;
    Email: string;
}
//G
//H
//I
export interface IInvoicingAddressViewModel {
    Address: IAddressViewModel;
    ContactPersonName: string;
    Reference: string;
    CompanyName: string;
    BusinessId: string;
    ContactPersonEmail: string;
    ContactPersonPhone: string;
    InvoicingNetworkAddress: string;
    InvoicingOperator: string;
    InvoicingDeliverCode: string;
    InvoicingFinIbanAddress: string;
    InvoicingFinDeliverCode: string;
    InvoicingFinOvtCode: string;
}

export class InvoicingAddressViewModel implements IInvoicingAddressViewModel {
    Address: IAddressViewModel = new AddressViewModel();
    ContactPersonName: string;
    Reference: string;
    CompanyName: string;
    BusinessId: string;
    ContactPersonEmail: string;
    ContactPersonPhone: string;
    InvoicingNetworkAddress: string;
    InvoicingOperator: string;
    InvoicingDeliverCode: string;
    InvoicingFinIbanAddress: string;
    InvoicingFinDeliverCode: string;
    InvoicingFinOvtCode: string;
}

//J
//K
//L
export interface ILinkedUserModel {
    LinkedUserId: number;
    UserName: string;
    LinkedUserName: string;
    CustomerFullName: string;
    Pin: string;
    Phone: string;
    Removed: boolean;
    //public AccessLevelEnum AccessLevel { get; set; }
    //public string AccessLevelDescription { get { return this.AccessLevel.GetDescription(); } }
    AccessLevelDescription: string;
    LinkedUserAuthenticationGuid: string;
    LinkedUserAuthenticationEmail: string;

    Invoicing?: AccessLevelEnum;
    InvoicingDescription: string;
    CustomerInformation?: AccessLevelEnum;
    CustomerInformationDescription: string;
    Contacts?: AccessLevelEnum;
    ContactsDescription: string;
    Contracts?: AccessLevelEnum;
    ContractsDescription: string;
    Outages?: AccessLevelEnum;
    OutagesDescription: string;
    Reports?: AccessLevelEnum;
    ReportsDescription: string;
    Messages?: AccessLevelEnum;
    MessagesDescription: string;
    ReadingEntry?: AccessLevelEnum;
    ReadingEntryDescription: string;


    GetAccessLevel: AccessLevelEnum;

    AccessLevels: Map<string, AccessLevelEnum>;//Dictionary < string, AccessLevelEnum >
}
//M
export interface IMeteringPointViewModel {
    Address: IAddressViewModel;
    CustomerCode: string;
    MeteringPointCode: string;
    ExternalMeteringPointCode: string;
    NetworkCompanyCode: string;
    NetworkCompanyName: string;
    FuseTypeId: number;
    TrustedSource: boolean;
    Id: number;
    Source: number;
    TarificationId: TarificationIdEnum;
    Energy1: number;
    Energy2: number;
    HousingTypeId: HousingTypeEnum;
    SourceCompanyCode: string;
    CISMeteringPointId: number;
    IsAmr : boolean;
    IsConnected: boolean;
    DisconnectionReason: string;
    DisconnectionDate: Date;
    IsSafeToConnect: boolean;
    AdditionalAddressToMeteringPointAddress: boolean;
    IsItellaAddressDatasConverted: boolean;
    GsrnCode: string;
    MeteringGridAreaCode: string;
    PhysicalStatusType: string;
    IsNetted: null | boolean;
    EnergyCommunityCode: string;
    EnergyCommunityName: string;
    RelatedMeteringPoint: string;
}

export interface IMultiUtilityMeteringPointViewModel {
    Customer: ICustomerViewModel;
    Address: IAddressViewModel;
    MeteringPoints: MultiUtilityMeteringPoint[];
    /// Metering point codes of meteringpoints with valid contract
    MeteringPointsWithValidContract: string[];
}

export class MultiUtilityMeteringPoint {
    Item1: IUtilityType;
    Item2: IMeteringPointViewModel;
}

export class MeteringPointViewModel implements IMeteringPointViewModel {
    Address: IAddressViewModel = new AddressViewModel();
    CustomerCode: string;
    MeteringPointCode: string;
    ExternalMeteringPointCode: string;
    NetworkCompanyCode: string;
    NetworkCompanyName: string;
    FuseTypeId: number;
    TrustedSource: boolean;
    Id: number;
    Source: number;
    TarificationId: TarificationIdEnum;
    Energy1: number;
    Energy2: number;
    HousingTypeId: HousingTypeEnum;
    SourceCompanyCode: string;
    CISMeteringPointId: number;
    IsAmr: boolean;
    IsConnected: boolean;
    DisconnectionReason: string;
    DisconnectionDate: Date;
    IsSafeToConnect: boolean;
    AdditionalAddressToMeteringPointAddress: boolean;
    IsItellaAddressDatasConverted: boolean;
    GsrnCode: string;
    MeteringGridAreaCode: string;
    PhysicalStatusType: string;
    IsNetted: null | boolean = null;
    EnergyCommunityCode: string;
    EnergyCommunityName: string;
    RelatedMeteringPoint: string;
}

export interface IMoveOutConsumptionPointViewModel {
    Address: IAddressViewModel;
    MeteringPoints: IMoveOutMeteringPointViewModel[];
    UtilityTypeId: UtilityTypeEnum;
}

export interface IMoveOutContractViewModel {
    ContractCode: string;
    ContractTypeId: number;
    UtilityTypeId: number;
    MoveOutDate: Date;
    CustomerCode: string;
    SourceCompanyCode: string;
}

export interface IMoveOutMeteringPointViewModel {
    MeteringPointCode: string;
    Contracts: IMoveOutContractViewModel[];
    MeteringPointAddress: IAddressViewModel;
}

export interface IMoveOutProcessViewModel {
    MoveOutProcessId: number;
    CustomerType: number;
    ConsumerCustomer: ICustomerViewModel;
    CompanyCustomer: ICompanyViewModel;
    MoveOutStatus: number;
    MoveOutDate: Date;
    ConsumptionPoints: IMoveOutConsumptionPointViewModel[];
    FinalInvoicingAddress: IFinalInvoicingAddressViewModel;
}

//N
//O
export interface IOtherContractViewModel {
    Id: number;
    ContractCode: string;
    CustomerCode: string;
    CustomerName: string;
    Pin: string;
    StartDate: Date;
    EndDate: Date;
    FixedTimeUntilDate: Date;
    IsFixedTime: boolean;
    Status: CISContractStatusEnum;
    UtilityTypeId: UtilityTypeEnum;
    ContractTypeId: ContractTypeEnum;
    MeteringPoint: IMeteringPointViewModel;
    InvoiceGroupCode: string;
    DueDate: Date;
    ExternalProductId: string;
    ExternalProductName: string;
    SourceCompanyCode: string;
    ProductId: number;
    PriceListId: number;
    InvoicingMethod: InvoicingMethodEnum;
    BackgroundContractCode: string;
}

//P
export interface IPaymentDefaultViewModel {
    Id: number;
    PaymentDefaultCode: string;
    PaymentDefaultDate: Date;
    PaymentDefaultDate2: Date;
    AmountOfPaymentDefault: string;
    Creditor: string;
    DebtType: string;
    DebtTypeText: string;
    Reference: string;
    DebtPayedDate: Date;
    PaymentDefaultText: string;
    DiaryNumber: string;
    GroupIdentifier: string;
}

export interface IPriceListAvailabilityViewModel {
    Id: number;
    RuleType: RuleTypeEnum;
    RuleValue: number;
    Rule: number;
}

export interface IPriceListServiceProductViewModel {
    ServicePriceList: IPriceListViewModel;
    PriceListServiceProductType: number;
}

export interface IPriceListViewModel {
    Id: number;
    Name: string;
    ExternalPriceListId: string;
    ExternalPriceListId2: string;
    Description: string;
    FixedTerm: boolean;
    FixedTermDuration: number;
    FixedTermDurationUnit: number;
    FixedTermEndDate: Date;
    FixedTermAbsoluteEndDate: Date;
    PricingType: number;
    ProductComponents: IProductComponentViewModel[];
    OrderNumber: number;
    CampaignCode: string;
    CampaignName: string;
    CampaignDescription: string;
    CampaignRestricted: boolean;
    ShortDescription: string;
    InvoicingRule: number;
    DeliveryStartDate: Date;
    HasWoodWaterProductionManner: boolean;
    HasWindProductionManner: boolean;
    HasSunProductionManner: boolean;
    PriceListAvailabilities: IPriceListAvailabilityViewModel[];
    PriceListServiceProducts: IPriceListServiceProductViewModel[];
    CountOfMandatoryServiceProducts: number;
    CountOfOptionalServiceProducts: number;
}

export interface ISelectedServiceProductViewModel {
    PriceListId: number;
    ServiceProductExternalPriceListId: string;
    ServiceProduct: IPriceListServiceProductViewModel;
}

export interface IProductAvailabilityViewModel {
    Id: string;
    RuleType: RuleTypeEnum;
    RuleValue: number;
    Rule: number;
}

export interface IProductComponentViewModel {
    Id: number;
    Name: string;
    Description: string;
    TarificationId: TarificationIdEnum
    TarificationName: string;
    PriceStartDate: Date;
    BasicDescription: string;
    BasicPriceUnit: string;
    BasicPrice: number;
    BasicPriceNoVAT: number;
    FuturePriceStartDate: Date;
    FutureBasicPrice: number;
    FutureBasicPriceNoVAT: number;
    Energy1Price: number;
    Energy1PriceNoVAT: number;
    Energy1PriceLabel: string;
    Energy1Description: string;
    Energy1PriceUnit: string;
    FutureEnergy1Price: number;
    FutureEnergy1PriceNoVAT: number;
    Energy2Price: number;
    Energy2PriceNoVAT: number;
    Energy2PriceLabel: string;
    Energy2Description: string;
    Energy2PriceUnit: string;
    Energy1BundleDescription: string;
    Energy2BundleDescription: string;
    Energy1BundlePrice: number;
    Energy1BundlePriceNoVat: number;
    Energy2BundlePrice: number;
    Energy2BundlePriceNoVat: number;
    FutureEnergy2Price: number;
    FutureEnergy2PriceNoVAT: number;
    TotalPrice: number;
    TotalPriceNoVAT: number;
    FutureTotalPrice: number;
    FutureTotalPriceNoVAT: number;
    TotalConsumption: number;
    AlternativePrices: IAlternativePriceViewModel[];
    ThisMonthForFuturePrice: string;
    NextMonthForFuturePrice: string;
    ExternalId: string;
    ServiceDescription: string;
    ServicePriceUnit: string;
    ServicePriceUnitTranslated: string;
    ServicePrice: number;
    ServicePriceNoVAT: number;
    SpotEnergy1MarginalPrice: number;
    SpotEnergy1MarginalPriceNoVAT: number;
    SpotEnergy1MarginalDescription: string;
    SpotEnergy1MarginalPriceUnit: string;
    SpotEnergy2MarginalPrice: number;
    SpotEnergy2MarginalPriceNoVAT: number;
    SpotEnergy2MarginalDescription: string;
    SpotEnergy2MarginalPriceUnit: string;
    SpotPriceLimitFee: number;
    SpotPriceLimitFeeNoVAT: number;
    SpotPriceLimitFeeDescription: string;
    SpotPriceLimitFeeUnit: string;
    AdditionalBasicPrices: IAdditionalBasicPriceViewModel[];
}

export interface IProductGroupViewModel {
    Id: number;
    Name: string;
    Description: string;
    Code: string;
    CSSClass: string;
    Products: IProductViewModel[];

}

export interface IProductTypeViewModel {
    Id: number;
    Name: string;
    Description: string;
    Code: string;
}

export interface IProductViewModel {
    Id: number;
    Name: string;
    Description: string;
    MarketingURL: string;
    Icon: string;
    PriceLists: IPriceListViewModel[];
    ProductGroups: IProductGroupViewModel[];
    ProductTypes: IProductTypeViewModel[];
    ProductAvailabilities: IProductAvailabilityViewModel[];
    Rating: number;
    OrderNumber: number;
    CO2Emission : number;
    ShortDescription: string
    FeaturedEnergyPrice: number;
    FeaturedBasicPrice: number;
    Type : ProductTypeEnum;
}
//Q
//R
//S
export interface ISharedCustomerRightsViewModel {
    Id: number;
    CustomerCode: string;
    SourceCompanyCode: string;
    Contacts: UserMappingAccessLevelEnum;
    Contracts: UserMappingAccessLevelEnum;
    CustomerInformation: UserMappingAccessLevelEnum;
    Invoicing: UserMappingAccessLevelEnum;
    Messages: UserMappingAccessLevelEnum;
    Outages: UserMappingAccessLevelEnum;
    Reports: UserMappingAccessLevelEnum;
    ReadingEntry: UserMappingAccessLevelEnum;
    AccessLevels: Map<string, UserMappingAccessLevelEnum>;//IDictionary<string, UserMappingAccessLevelEnum>;
    User: IUserInfoViewModel;
}
//T
//U
export interface IUserInfoViewModel {
    UserInfoId: number;
    FirstName: string;
    LastName: string;
    Email: string;
    Username: string
    Features: IUserProfileFeatureViewModel[];
}

export interface IUserProfileFeatureViewModel {

    UserProfileFeatureId: number;
    FeatureTypeId: UserProfileFeatureTypeEnum;
    Value: string;
    Priority: number;
}

export interface IUtilityType {
    UtilityTypeId: number;
    Name: string;
    Name_sv: string;
    Name_en: string;
    Icon: string;
    Type: UtilityTypeEnum;
}

export class ProductAndPricelist {
    Name: string;
    Duration: string;
    PriceList: IPriceListViewModel;
    constructor(name: string, duration: string, priceList: IPriceListViewModel) {
        this.Name = name;
        this.Duration = duration;
        this.PriceList = priceList;
    }
}
//V
//X
//Y
//Z
